import MorePopover from '@/components/ui/MorePopover';
import { useModal } from '@bitstopco/bitstop-theme';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';

import ActionsPopover from '@/components/ui/ActionPopover';

import { RestockRequestStatus } from '@/types/generated/athena';

import type { RestockRequestView } from '@/types/generated/athena';

type Props = {
  data: RestockRequestView;
  type?: 'dots' | 'button';
};

const RestockingLoadOrderMenu = ({ data: { id, status }, type = 'dots' }: Props) => {
  const navigate = useNavigate();
  const { show } = useModal();

  const items = useMemo(() => {
    const basic = [
      {
        label: 'Fulfill Load Order',
        disabled: status !== RestockRequestStatus.Created,
      },
      {
        label: 'Create Reconciliation',
        disabled: status !== RestockRequestStatus.PendingReconcile,
      },
      {
        label: 'Make Adjustment',
        disabled: !(
          status === RestockRequestStatus.Fulfilled || status === RestockRequestStatus.Loaded
        ),
      },
      {
        label: 'Edit Load Order',
        disabled: status !== RestockRequestStatus.Created,
      },
      {
        label: 'Cancel Order',
        disabled: status !== RestockRequestStatus.Created,
      },
    ];
    if (type === 'dots') {
      basic.push({ label: 'See Details', disabled: false });
    }
    return basic;
  }, [type, status]);

  const handleClick = (index: number) => {
    switch (index) {
      case 0:
        show('fulfill-load-order', { id });
        break;
      case 1:
        show('create-reconciliation', { id });
        break;
      case 2:
        show('create-load-order-adjustment', { id });
        break;
      case 3:
        show('edit-load-order', { id });
        break;
      case 4:
        show('cancel-load-order', { id });
        break;
      case 5:
        navigate(`/restocking/load-orders/${id}`);
        break;
    }
  };

  return type === 'dots' ? (
    <MorePopover items={items} onClick={handleClick} />
  ) : (
    <ActionsPopover items={items} onClick={handleClick} />
  );
};

export default RestockingLoadOrderMenu;
